export default "__VITE_ASSET__DmIlAghd__"